var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  fill: "none",
  viewBox: "0 0 100 100"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M50 98c26.51 0 48-21.49 48-48S76.51 2 50 2 2 23.49 2 50s21.49 48 48 48m0 2C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M50.061 53.09q2.79 0 6.12.81 3.78.945 6.12 2.52 2.79 1.845 2.79 4.14v3.78h-30.06v-3.78q0-2.295 2.79-4.14 2.34-1.575 6.12-2.52 3.33-.81 6.12-.81m0-3.78a7.2 7.2 0 0 1-3.735-1.013 7.64 7.64 0 0 1-2.722-2.722 7.2 7.2 0 0 1-1.013-3.735q0-2.025 1.013-3.78a7.53 7.53 0 0 1 2.722-2.768 7.2 7.2 0 0 1 3.735-1.012q2.025 0 3.735 1.012a7.53 7.53 0 0 1 2.723 2.768 7.44 7.44 0 0 1 1.012 3.78q0 2.025-1.012 3.735a7.64 7.64 0 0 1-2.723 2.722 7.2 7.2 0 0 1-3.735 1.013M68.911 49.243h-4.166v4.167h-1.367v-4.167H59.21v-1.366h4.167V43.71h1.367v4.167h4.166z",
  clipRule: "evenodd"
})));
export default SvgAddUser;